import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const CartCounter = ({ count  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "shopping-bag"
    }), count > 0 && /*#__PURE__*/ React.createElement("span", {
        className: "cart-counter"
    }, count))
;

export { CartCounter, CartCounter as default };
//# sourceMappingURL=CartCounter.js.map
